/* eslint-disable prettier/prettier */
/* eslint-disable */

import React, { useState, useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";
import DefaultNavbar from "examples/Navbars/DefaultNavbar";
import Footer from "footer.routes";
import routes from "routes";
import { Card, Container, Grid } from "@mui/material";
import { Select, MenuItem, FormControl } from "@mui/material";
import MKBox from "components/MKBox";
import MKTypography from "components/MKTypography";
import './KontaktOss.css';
import bgImage from "assets/images/backgrounds/t-event-kontakt-oss-bg-cropped.jpg";
import mobileBgImage from "assets/images/backgrounds/t-event-kontakt-oss-bg-mobile.jpg";
import logo from "assets/images/logos/T-event/fulllogo_transparent.png";
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger);

function KontaktOss() {
  const [submitted, setSubmitted] = useState(false);
  const [type, setType] = useState("");
  const contactFormRef = useRef(null);
  const [isRedirectedFromLink, setIsRedirectedFromLink] = useState(false);

  const location = useLocation();

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const typeParam = params.get("type");
    if (typeParam) {
      setType(typeParam);
      setIsRedirectedFromLink(true);
    }
  }, [location]);

  useEffect(() => {
    if (isRedirectedFromLink && contactFormRef.current) {
      setTimeout(() => {
        window.scrollTo({
          top: contactFormRef.current.offsetTop,
          behavior: 'smooth',
        });
      }, 200);
    }
  }, [isRedirectedFromLink]);

  // Parallax-effekt på bakgrunnsbildet
  useEffect(() => {
    gsap.to(".hero-background", {
      scrollTrigger: {
        trigger: ".hero-background",
        start: "top bottom",
        end: "bottom top",
        scrub: true, // Dette sikrer en jevn scroll-effekt
        markers: false, // Deaktiver markører for testing (kan være nyttig for debugging)
      },
      y: "-20%", // Bakgrunnen beveger seg i forhold til rullen
      ease: "none",
      backgroundPosition: "center", // Sikre at bakgrunnsbildet beveger seg riktig
    });

    const handleResize = () => {
      const isMobile = window.innerWidth <= 768;
      setBackground(isMobile ? mobileBgImage : bgImage); // Set the background image dynamically
    };
  
    // Initial call and event listener for resize
    handleResize();
    window.addEventListener("resize", handleResize);
  
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const [background, setBackground] = useState(bgImage); // Default to the desktop background


  // Fade-in animasjon på kontaktformularen (bare på kortet)
  useEffect(() => {
    gsap.fromTo(
      ".contact-form-card", 
      { opacity: 0, y: 50 }, // Startposisjon
      {
        opacity: 1,
        y: 0, // Sluttposisjon
        duration: 1.5,
        delay: 1,
        ease: "power2.out",
        scrollTrigger: {
          trigger: ".contact-form-card",
          start: "top 100%", // Animasjonen starter når toppen av formularen er 80% synlig på skjermen
          toggleActions: "play none none none", // Spiller animasjonen når elementet ruller inn
        },
      }
    );
  }, []);

  // Fade-in på logo og tekst i hero-seksjonen
  useEffect(() => {
    gsap.fromTo(
      ".hero-logo",
      { opacity: 0, y: -50 }, // Startposisjon
      {
        opacity: 1,
        y: 0, // Sluttposisjon
        duration: 1.5,
        ease: "power2.out",
        scrollTrigger: {
          trigger: ".hero-background",
          start: "top 70%", // Animasjonen starter når toppen av hero-seksjonen er 70% synlig på skjermen
          toggleActions: "play none none none", // Spiller animasjonen når elementet ruller inn
        },
      }
    );

    gsap.fromTo(
      ".hero-text",
      { opacity: 0, y: 30 }, // Startposisjon
      {
        opacity: 1,
        y: 0, // Sluttposisjon
        duration: 1.5,
        delay: 0.5, // Teksten kommer etter logoen
        ease: "power2.out",
        scrollTrigger: {
          trigger: ".hero-background",
          start: "top 70%", // Animasjonen starter når toppen av hero-seksjonen er 70% synlig på skjermen
          toggleActions: "play none none none", // Spiller animasjonen når elementet ruller inn
        },
      }
    );
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
    const formData = new FormData(e.target);

    try {
      const response = await fetch('https://api.web3forms.com/submit', {
        method: 'POST',
        body: formData,
      });

      if (response.ok) {
        setSubmitted(true);
      } else {
        alert("There was an issue with the submission. Please try again.");
      }
    } catch (error) {
      console.error("Error submitting the form:", error);
      alert("An error occurred. Please try again.");
    }
  };

  return (
    <>
      <DefaultNavbar routes={routes} />

      {/* HERO SECTION */}
      <MKBox
          minHeight="100vh"
          width="100%"
          position="relative"
          sx={{
            backgroundImage: `url(${background})`, // Dynamically change the background
            backgroundSize: "cover",
            backgroundPosition: "center",
            backgroundAttachment: "fixed",
            backgroundRepeat: "no-repeat",
            display: "grid",
            placeItems: "center",
            overflow: "hidden",
          }}
        >
        <MKBox
          sx={{
            position: "absolute",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            background: "rgba(0, 0, 0, 0.6)",
            zIndex: 1,
          }}
        />
        <Container sx={{ position: "relative", zIndex: 3, textAlign: "center" }}>
          <Grid container direction="column" alignItems="center" justifyContent="center" xs={12} lg={7} mx="auto">
            <MKBox
              component="img"
              src={logo}
              alt="T-Events Logo"
              width={{ xs: "200px", sm: "250px", md: "350px" }}
              mb={2}
              sx={{
                filter: "brightness(0) invert(1)",
                display: "block",
                mx: "auto",
                marginTop: { xs: "40px", md: "80px" },
              }}
              className="hero-logo"
            />
            <MKTypography
              variant="h1"
              color="white"
              textAlign="center"
              px={{ xs: 4, lg: 10 }}
              mt={1}
              sx={{
                fontSize: { xs: "28px", sm: "36px", md: "42px" },
                fontWeight: 200,
              }}
              className="hero-text"
            >
              KONTAKT OSS
            </MKTypography>
            <MKTypography
              variant="h5"
              color="white"
              textAlign="center"
              px={{ xs: 4, lg: 10 }}
              mt={1}
              sx={{ fontSize: '18px', fontFamily: "'Montserrat', sans-serif", fontWeight: 300 }}
              className="hero-text"
            >
              Vi er her for å hjelpe deg med eventuelle spørsmål!
            </MKTypography>
          </Grid>
        </Container>
      </MKBox>

      {/* KONTAKTSKJEMA */}
      <Card
        className="contact-form-card"
        sx={{
          p: 2,
          mx: { xs: 2, lg: 3 },
          mt: -7,
          mb: 4,
          position: "relative",
          zIndex: 4,
          backgroundColor: "white",
          backdropFilter: "saturate(200%) blur(30px)",
          boxShadow: ({ boxShadows: { xxl } }) => xxl,
          borderRadius: "16px",
        }}
        ref={contactFormRef}
      >
        {submitted ? (
          <section className="thank-you" style={{ textAlign: "center", padding: "20px" }}>
            <h2>Takk for din forespørsel!</h2>
            <p>Vi svarer deg så raskt vi kan.</p>
          </section>
        ) : (
          <section className="contact-form">
            <div className="form-container">
              <h2>Send oss en melding</h2>
              <form onSubmit={handleSubmit}>
                <input type="hidden" name="access_key" value="438bbe60-3174-4e82-aadd-bc27c6850b2b" />
                <input type="hidden" name="type" value={type} />
                <label htmlFor="name">Navn</label>
                <input type="text" id="name" name="name" required placeholder="Skriv navnet ditt" />
                <label htmlFor="email">E-post</label>
                <input type="email" id="email" name="email" required placeholder="Skriv e-posten din" />
                <FormControl sx={{ width: "100%", marginBottom: "20px" }} required>
                  <label htmlFor="type">Type forespørsel</label>
                  <Select
                    labelId="type-label"
                    id="type"
                    name="type"
                    value={type || "Velg"}
                    onChange={(e) => setType(e.target.value)}
                    sx={{ height: "45px", display: "flex", alignItems: "center" }}
                  >
                    <MenuItem value="Velg" disabled>Velg</MenuItem>
                    <MenuItem value="lydutstyr">Lydutstyr</MenuItem>
                    <MenuItem value="lysutstyr">Lysutstyr</MenuItem>
                    <MenuItem value="spesialeffekter">Spesialeffekter</MenuItem>
                    <MenuItem value="dj">DJ & Musikere</MenuItem>
                    <MenuItem value="eventutstyr">Eventutstyr</MenuItem>
                    <MenuItem value="generelt">Generelt</MenuItem>
                  </Select>
                </FormControl>

                <label htmlFor="message">Melding</label>
                <textarea id="message" name="message" required placeholder="Skriv meldingen din" rows="5"></textarea>
                <button type="submit">Send</button>
              </form>
            </div>
          </section>
        )}
      </Card>

      <Footer />
    </>
  );
}

export default KontaktOss;